/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import React from 'react';
// utils
import { generateClasses } from 'utils/generators';
// styles
import injectSheet from 'react-jss';
import styles from 'material/menu/menuitem/menuitem_styles';



/* ========== ~~~~~~~~~~ MENU > ITEM : CHILD ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// this child component handles local state and uses props passed from parent to read/write application state when necessary
const MenuItem = (props) => {
	const handleClick = (e) => {
		props.updateMenuState(e);
	};
	return (
        <div className={`menuitem ${generateClasses(props)} ${props.classes.menuitem} disabled-${!!props.disabled}`} onClick={handleClick}>
        	{props.children}
        </div>
	);
};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(MenuItem);